export const LayerType = {
    AXIS_NET: "sys_轴网", // 轴网
}

// export const LayerTypeList = [
//     { value: 201, label: '轴网' },
// ]

// export function getLayerTypeName(layerType: number) {
//     let label = LayerTypeList.find(item => item.value === layerType)?.label || null;
//     return label
// }